export const clipText = (maxLength: number) => (text: string) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength).trim() + '…';
  }
  return text;
};
